export const fromInvoiceConfirmFields = {
  FILE: 'fileId',
};
